module.exports = __webpack_public_path__ + "img/video-28.5e94223c.png";